import React from "react";
import {Box, Card, CardContent, Checkbox, Divider, Grid, IconButton, Typography} from "@mui/material";
import {formatDate} from "~/apps/core/utils";
import moment from "moment";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {BorderedBox} from "~/apps/core/ui/BorderedBox";
import {Tag} from "~/apps/core/ui/Tag";
import {humanizeCargoTag} from "~/apps/packages/cargos/utils";
import {OrdersListStatusBadge} from "~/apps/packages/auto-shipment-orders/components/OrdersList/OrdersListStatusBadge";
import {Close, InformationCircle} from "~/ui/icons";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import makeStyles from "@mui/styles/makeStyles";
import {OrderItemCargo} from "~/apps/packages/auto-shipment-orders/queries";
import {
    OrderCargoCardStatusBadge
} from "~/apps/packages/auto-shipment-orders/components/OrderDetail/OrderCargoCard/OrderCargoCardStatusBadge";

const useStyles = makeStyles(() => ({
    checkbox: {
        position: 'absolute',
        top: 0,
        right: 10,
        zIndex: 999
    },
    deleteButton: {
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 999,
        width: '24px'
    }
}))

type OffersCargoCardProps = {
    selectable?: boolean
    deletable?: boolean
    selected?: boolean
    cargo: OrderItemCargo
    onRemoveClick?: () => void
}

export const OrderCargoCard = (props: OffersCargoCardProps) => {
    const { selectable, cargo, selected, deletable, onRemoveClick } = props;
    const classes = useStyles();
    return (
        <Card>
            <CardContent>
                <Grid container direction="column" wrap="nowrap" rowSpacing="8px">
                    <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
                        <Grid item container direction="column">
                            <Grid
                                item
                                container
                                direction="row"
                                justifyContent="space-between"
                                wrap="nowrap"
                                position="relative"
                            >
                                {!selectable && !deletable && <OrderCargoCardStatusBadge>
                                    {cargo.status}
                                </OrderCargoCardStatusBadge>}
                                {selectable && <Grid item>
                                    <Checkbox
                                        edge="end"
                                        color="additionalPrimary"
                                        checked={selected}
                                        onClick={e => null}
                                        className={classes.checkbox}
                                    />
                                </Grid>}
                                {
                                    deletable &&
                                        <IconButton
                                            onClick={onRemoveClick}
                                            size="mini"
                                            className={classes.deleteButton}
                                        >
                                            <Close/>
                                        </IconButton>

                                }
                            </Grid>
                            <Typography
                                variant="cardTitle2"
                                color="#081F32"
                                sx={{
                                    marginTop: selectable ? '6px' : '8px'
                                }}
                            >
                                {cargo.container?.number || cargo?.name}
                                {cargo.container?.type && <BorderedBox marginLeft="8px" variant="cardText" height="20px">
                                    {cargo.container.type}
                                </BorderedBox>}
                            </Typography>
                            {cargo.description && <Typography variant="cardText" color="#B6BBC5" marginTop="6px">
                                {cargo.description}
                            </Typography>}
                            {cargo.tags && cargo.tags.agentRelease === true && <Grid item marginTop={1}>
                                <Grid container spacing="8px">
                                    <Grid item>
                                        <Tag>
                                            Откреплен
                                        </Tag>
                                    </Grid>
                                </Grid>
                            </Grid>}
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Divider/>
                    </Grid>
                    {cargo.arrival?.document && <Grid item>
                        <TypographyWithLabel label={cargo.arrival.document?.type}>
                            {cargo.arrival.document?.number} от {formatDate(moment(cargo.arrival.document?.date))}
                        </TypographyWithLabel>
                    </Grid>}
                    {cargo.status?.toLowerCase() === 'отклонен портом' && cargo.statusDescription && <Grid item>
                        <Box
                            padding="8px"
                            sx={{
                                borderRadius: '3px',
                                backgroundColor: 'rgba(229, 51, 40, 0.10)'
                            }}
                        >
                            <Typography variant="cardText">
                                Причина отклонения
                            </Typography>
                            <Typography variant="screenSubtitle" color="#8797A9" display="block">
                                {cargo.statusDescription}
                            </Typography>
                        </Box>
                    </Grid>}
                </Grid>
            </CardContent>
        </Card>
    )
}
